/**
 * 获取错误类型的对象
 * @function typeError
 * @param {string} name - 展现的参数名
 * @param {string} wanted - 需要的类型字符串
 * @param {any} obj - 错误的类型对象
 * @return {TypeError} 返回错误类型
 */
const typeError =  (name, wanted, obj) => new TypeError('Expected `' + name
+ '` to be of type `' + wanted
+ '`, got `' + typeof obj + '`');

/**
 * @function type
 * @param {any} obj - 被判断的对象
 * @return {string} 返回类型：array/date/string/object/undefined/function/boolean/null/regexp/math 等
 */
const getType = obj => Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();

/**
* 根据传入的类型使用 Object.toString 进行判断
* @function isType
* @param {any} obj - 需要判断的类型
* @param { string} type - 需要判断的类型字符串
* @return {boolean} 返回判断结果
* @example
* isType('', 'String') // true
* isType(new Date, 'Date') // true
* isType('', 'Array') // false
*/
const isType = (obj, type) => {
    return getType(obj) === type.toLowerCase();
};

/**
 * 日期格式化
 * @author wangyongqing01
 * @function dateFormat
 * @param {Date} d - date 对象
 * @param {string} [pattern = 'yyyy-MM-dd'] - 字符串
 * @return {string} 处理后的字符串
 * @example
 *	var d = new Date();
 *  dateFormat(d," yyyy年M月d日\n yyyy-MM-dd\n MM-dd-yy\n yyyy-MM-dd hh:mm:ss")
 *  //2018年11月10日\n 2018-01-01\n 01-01-18\n 2018-11-12 12:01:02
 */
export const formatDate = (d, pattern = 'yyyy-MM-dd') => {
    if (!isType(d, 'date')) {
        throw typeError('d', 'Date', d);
    }

    let y = d.getFullYear().toString();
    let o = {
        M: d.getMonth() + 1, // month
        d: d.getDate(), // day
        h: d.getHours(), // hour
        m: d.getMinutes(), // minute
        s: d.getSeconds() // second
    };
    pattern = pattern.replace(/(y+)/gi, (a, b) => y.substr(4 - Math.min(4, b.length)));
    Object.keys(o).forEach(i => {
        // eslint-disable-next-line
        pattern = pattern.replace(new RegExp('(' + i + '+)', 'g'), (a, b) =>
            o[i] < 10 && b.length > 1 ? '0' + o[i] : o[i]
        );
    });
    return pattern;
};

/**
 * 用于标准时间
 * @param time 时戳,毫秒为单位
 */
const getGLWZTime = time => {
    // 计算格林威治时间和本地时间之间相差几个小时
    let hours = new Date().getTimezoneOffset() / 60;
    // 毫秒为单位的时差
    let millisecond = hours * 3600000;
    // 标准时间戳 = 传入时间戳 + 北京与格林威治的时差（传入时间戳以北京为基础）
    let standardTime = time + (8 * 3600000);
    // 当前时区时间 =  标准时间戳 + 本地与格林威治时差
    let currentZone = standardTime +  millisecond;
    return currentZone;
};

/**
 * 用于返回头部时间（统一显示年-月-日 时:分）
 * @param time 时戳
 */
export const getYearDate = time => {
    time = +time;
    if (isNaN(time)) {
        return '';
    }
    const tar = new Date(getGLWZTime(time));
    return formatDate(tar, 'yyyy-MM-dd hh:mm');
};
